import React, { type JSX } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Executive Clarity hero band — signature eid-hero gradient from the brand kit.
 * Shown on Home only for the platform empowerid theme (not other dedicated tenants).
 */
export function EmpowerIdHomeHero({ greeting }: { greeting: string }): JSX.Element | null {
  const { theme } = useTheme();
  if (theme !== 'empowerid') return null;

  return (
    <section
      data-testid="empowerid-home-hero"
      aria-label="Welcome"
      style={{
        marginBottom: 16,
        padding: '20px 28px',
        borderRadius: 16,
        background: 'var(--gradient-text-hero, linear-gradient(135deg, #101A32 0%, #1E3A89 48%, #0A3D8F 100%))',
        boxShadow: 'var(--shadow-colored, 0 8px 24px rgba(10, 61, 143, 0.14))',
        color: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <p
        style={{
          margin: '0 0 6px',
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: '#D6E6FF',
        }}
      >
        EmpowerID Identity Fabric
      </p>
      <h1
        style={{
          margin: '0 0 8px',
          fontSize: 'clamp(1.375rem, 2.5vw, 1.75rem)',
          fontWeight: 300,
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
          fontFamily: "var(--font-display, 'Rubik', system-ui, sans-serif)",
          color: '#ffffff',
        }}
      >
        {greeting}
      </h1>
      <p
        style={{
          margin: 0,
          fontSize: 'clamp(0.9375rem, 1.8vw, 1.0625rem)',
          fontWeight: 500,
          color: '#ffffff',
          maxWidth: 640,
          lineHeight: 1.4,
        }}
      >
        Govern every identity. Control every action. Prove every outcome.
      </p>
    </section>
  );
}
